/**
 * 行人过街图片实体
 * zxw
 * 2024-09-26
*/
import React, { Component } from 'react';
import { Modal, Input,Row,Col, message, 
    Select, Upload,
} from 'antd';
import $ from 'jquery';
import { PlusOutlined } from '@ant-design/icons';
import { AddRequestHeaders,UjoinParams,AliyunOSSclient, UUID } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '行人过街图片'

const Option = Select.Option;

const uploadButton = (
    <button style={{
        border: 0,
        background: 'none',
        cursor: 'pointer'
    }} type="button"
    >
        <PlusOutlined />
        <div style={{ marginTop: 8,}}>上传图片</div>
    </button>
);

class Entity extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            ulid: '',
            walkwayUlid: '',
            walkwayName: '',
            name: '',
            url: '',
            path: '',
            fileList: [],
        }
    }

    changeWalkwayUlid = (value, operations) =>{
        this.setState({ 
            walkwayUlid: value,
            walkwayName: operations.children,
        });}
    changeName = (e) =>{this.setState({name: e.target.value});}

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    aliyunOSSUpload = (file) =>{
        const _this = this;
        var params = {
            'oss': 'PutObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onloadend = () => {
                                // _this.setState({fileName: file.name});
                                //  路径由以下部分组成
                                //  项目代码+组织前缀+路口Ulid+附件名（去除空格）
                                var path = CNF.projectCode.toLowerCase() + '/' 
                                path += _this.props.preGroup + '/' 
                                path += _this.state.walkwayUlid + '/'
                                path += UUID;
                                path += '.' + file.name.replace(/\s/g, '').split('.').slice(-1)[0];
                                AliyunOSSclient(token).multipartUpload(path, file, 
                                {
                                    //  获取分片上传进度、断点和返回值
                                    progress: (p, cpt, res)=>{
                                        //  获取最新的文件列表
                                        let newFileList = _this.state.fileList;
                                        //  获取最新的文件实体
                                        let newFile = newFileList[newFileList.length - 1];
                                        newFile.percent = parseInt(p * 100);
                                        if(p === 1){
                                            //  文件上传完成
                                            newFile.uid = '1';
                                            newFile.status = 'done';
                                            newFile.url = 'https://cfmsoss.oss-cn-shenzhen.aliyuncs.com/' + path;
                                            newFile.path = path;
                                        }
                                        newFileList[newFileList.length - 1] = newFile;
                                        _this.setState({ fileList: newFileList });
                                    }, 
                                    //  分分片数量
                                    parallel: Math.ceil(file.size/1024/1024),
                                    //  设置分片大小，默认为1M。
                                    partSize: 1024 * 1024,
                                    mime: "text/plain",
                                }).then((result) => {
                                    //  获取url
                                    let url = path
                                    if(result.res.status === 200){
                                        url = result.res.requestUrls[0].split('?')[0];
                                    }
                                    //  获取文件名，去掉后缀
                                    let arr = file.name.replace(/\s/g, '').split('.');
                                    let fileName = arr.slice(0, arr.length - 1).join('.');
                                    //  存储路径
                                    _this.setState({ 
                                        name: fileName,
                                        path: path, 
                                        url: url 
                                    });
                                }).catch((e) =>{
                                    //  上传失败
                                    console.log(e);
                                    message.error(file.name + ' 上传失败！');
                                });
                            }
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
        return false
    }

    /**
     * 从阿里云下载
     * @param {*} file
     */
    aliyunOSSDownload = (file) =>{
        const _this = this;
        
        var params = {
            'oss': 'GetObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        //  去掉路径‘/’
                        let result = AliyunOSSclient(token).signatureUrl(file.path, {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + file.name + '"'
                            }
                        });
                        let fileList = [{
                            url: result,
                            preview: result,
                            name: file.name,
                            status: 'done',
                            percent: 100,
                            path: file.path,
                            uid: file.key,
                        }];
                        _this.setState({ fileList: fileList,});
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
    }

    /**
     * 从阿里云删除
     * @param {*} file 
     * @returns 
     */
    aliyunOSSDelete = (file) => {
        var params = {
            'oss': 'DeleteObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        AliyunOSSclient(token).delete(file.path);
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
        return false
    }

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    beforeUpload = (file) =>{
        //  判断格式
        if(!['image/png','image/jpg','image/jpeg'].includes(file.type)){
            message.error('上传图片格式错误！', 1.5);
            return false;
        }
        if (file.size > 104857600){
            message.error('上传附近超过10M，建议拆分文件！', 1.5);
            return false;
        }
        return true;
    }

    /**
     * 上传图片
     * @param {*} file 
     */
    uploadImage = (file) =>{
        //  图片上传至阿里云前动作
        this.aliyunOSSUpload(file);
    }

    create = () =>{
        const _this = this;

        //  执行创建
        $.ajax({
            url: `${CNF.api}walkway/images`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'walkway_ulid': this.state.walkwayUlid,
                'walkway_name': this.state.walkwayName,
                'name': this.state.name,
                'path': this.state.path,
                'url': this.state.url,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({ loading: false });
                }
            }
        });
    };

    update = () =>{
        const _this = this;

        //  执行更新
        $.ajax({
            url: `${CNF.api}walkway/images/${this.state.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'walkway_ulid': this.state.walkwayUlid,
                'walkway_name': this.state.walkwayName,
                'name': this.state.name,
                'path': this.state.path,
                'url': this.state.url,
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                    setTimeout(function(){
                        _this.handleCancel();
                        _this.props.isRefresh();
                    }, 1500);
                }else{
                    message.error(data.msg, 1.5);
                    _this.setState({ loading: false });
                }
            }
        });
    };

    handleOk = () =>{
        //  参数校验
        if(this.state.walkwayUlid === ''){
            message.error('行人过街不能为空！');
            return;
        }
        if(this.state.name === ''){
            message.error('图片名称不能为空！');
            return;
        }
        this.setState({loading: true});
        if (this.props.record){
            this.update();
        }else{
            this.create();
        }
    };
    
    handleCancel = () =>{
        this.props.setIsModalOpen(false);
        this.setState({
            loading: false,
            ulid: '',
            walkwayUlid: '',
            walkwayName: '',
            name: '',
            url: '',
            path: '',
            fileList: [],
        });
    };

    componentDidUpdate(){
        if (this.props.record && this.state.ulid !== this.props.record.key){
            this.setState({
                record: this.props.record,
                ulid: this.props.record.key,
                walkwayUlid: this.props.record.walkway_ulid,
                walkwayName: this.props.record.walkway_name,
                name: this.props.record.name,
                path: this.props.record.path,
                url: this.props.record.url,
            });
            //  从阿里云上获取图片
            this.aliyunOSSDownload(this.props.record);
        }
    }
  
    render() {
        return (
            <div>
                <Modal
                    width={648}
                    style={{ top: 0 }}
                    title={(this.props.record?'修改':'创建') + MODULENAME}
                    open={this.props.isModalOpen}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    keyboard={true}
                    className='walkway-image-modal'
                    // mask={false}
                    okText='确认'
                    cancelText='取消'
                    okButtonProps={{ disabled: this.state.loading }}
                >
                    <Row style={{ marginTop: 5,lineHeight: 2.2 }}>
                        <Col span={4}>行人过街：</Col>
                        <Col span={20}>
                            <Select 
                                showSearch
                                value={this.state.walkwayUlid.toString()}
                                style={{ width: '100%' }} 
                                onChange={this.changeWalkwayUlid}
                                disabled={this.props.record?true:this.state.loading}
                                filterOption={(input, option) =>
                                    option.props.children.indexOf(input) >= 0
                                }
                            >
                                <Option value=''>选择行人过街</Option>
                                {
                                    this.props.walkwayDDList.length && this.props.walkwayDDList.map((item) => {
                                        return <Option key={item['key']} value={item['key'].toString()}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={4}>图片名称：</Col>
                        <Col span={20}>
                            <Input
                                onChange={this.changeName}
                                placeholder='必填字段'
                                value={this.state.name}
                                disabled={this.state.loading}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 5, lineHeight: 2.2 }}>
                        <Col span={5} offset={4}>
                            {/* <ImgCrop modalOk='确认' modalCancel='取消'> */}
                            <Upload
                                beforeUpload={this.beforeUpload}
                                name='file'
                                listType='picture-card'
                                icon={<PlusOutlined />}
                                customRequest={(option)=>{this.uploadImage(option.file);}}
                                // disabled={this.state.walkwayUlid?false:true}
                                fileList={this.state.fileList}
                                // onPreview={this.handlePreview}
                                // preview={false}
                                previewFile={false}
                                onChange={({fileList: newFileList})=>{
                                    this.setState({fileList: newFileList});
                                }}
                                showUploadList={{showPreviewIcon: false}}
                                onRemove={(file)=>{
                                    //  从阿里云上删除
                                    this.aliyunOSSDelete(file);
                                }}
                            >
                                {this.state.fileList.length >=1 ? null: uploadButton}
                            </Upload>
                        </Col>
                    </Row>
                </Modal>
            </div>
        );
    }
}

export default Entity